import { render } from "./RegisterCardSuccess.vue?vue&type=template&id=5b320d80&scoped=true"
import script from "./RegisterCardSuccess.vue?vue&type=script&lang=js"
export * from "./RegisterCardSuccess.vue?vue&type=script&lang=js"

import "./RegisterCardSuccess.vue?vue&type=style&index=0&id=5b320d80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b320d80"]])

export default __exports__